import { Option } from '../../../types';
import { getCountPages } from '../utils';

export const getPageSelectOptions = (entriesPerPage: number, totalEntries: number): Option[] => {
  const pageSelectOptions: Option[] = [];
  const countPages = getCountPages(totalEntries, entriesPerPage);
  for (let pageNumber = 1; pageNumber <= countPages; pageNumber++) {
    pageSelectOptions.push({ value: (pageNumber - 1).toString(), label: pageNumber.toString() });
  }

  return pageSelectOptions;
};
